import React, { Component } from "react";
import { Link } from "react-router-dom";

class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listItem: [
        {
          id: 1,
          icon: "fa fa-check",
          title: "Strong Cultural Grounding",
        },
        {
          id: 2,
          icon: "fa fa-check",
          title: "Clear Self-Regulation Teaching",
        },
        {
          id: 3,
          icon: "fa fa-check",
          title: "Inclusion and Equity",
        },
        {
          id: 4,
          icon: "fa fa-check",
          title: "Resources for Parents and Educators",
        },
      ],
    };
  }
  render() {
    return (
      <section className="banner pb-80" id="home">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-12 col-lg-6">
              <div className="banner-content ">
                <span className="subheading">
                  A free picturebook for children to learn
                </span>
                <h1>Self Regulation</h1>
                <ul>
                  {this.state.listItem.map((data, i) => (
                    <li key={i}>
                      <i className={data.icon}></i> {data.title}
                    </li>
                  ))}
                </ul>
                <Link to="/book-details" className="btn btn-main">
                  Read Now
                </Link>
                <p>
                  Interested in collaboration?{" "}
                  <a
                    href="mailto:rkot0010@student.monash.edu,dsar0022@student.monash.edu?subject=Collaboration%20about%20picture%20book"
                    className=""
                  >
                    Lets connect
                  </a>
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="banner-img">
                <img
                  src="assets/images/banner/book.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Banner;
